export default __webpack_public_path__ + "static/media/phone-icon.7e79ebd1.svg";